import { TableCell, TableRow } from "@mui/material";
import Search from "@mui/icons-material/Search";
import { useEffect, useState } from "react";

// COMPONENTS
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { getTranslateByKey, openNewTab } from "@/main/services/utils";

import { supplierInventoryHistoryApi } from "@/main/api";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { SupplierInventoryRequest } from "@/main/models/request";
import { SupplierInventoryDataResponse, SupplierInventoryGridHistoryResponse } from "@/main/models/response";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { SupplierInventoryHistoryEnum } from "@/main/services/enum/SupplierInventoryHistoryEnum";
import { formatDateToISOString } from "@/main/services/utilsDate";

import InventoryEdit from "./components/inventoryEdit";
import PartImport from "./components/partImport";
import * as SP from "../styles";
import * as S from "./styles";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";

interface ISectionHistoryProps {
	guidSupplierInventory: string | null;
	dataInventory: SupplierInventoryDataResponse | null;
}

function SectionHistory({ dataInventory, guidSupplierInventory }: ISectionHistoryProps) {
	// Constants
	const ID_SCROLLABLE_TARGET = "id-scrollable-target-historyinventory";

	const [openPartImport, setOpenPartImport] = useState<boolean>(false);
	const [openInventoryEdit, setOpenInventoryEdit] = useState<boolean>(false);
	const [guidSupplierInventoryDetail, setGuidSupplierInventoryDetail] = useState<string>("");
	const [userName, setUserName] = useState<string>("");
	const [dataRowHistory, setDataRowHistory] = useState<SupplierInventoryGridHistoryResponse | null>(null);
	const [formFiltersHistory, sertFormFiltersHistory] = useState<SupplierInventoryRequest | null>(null);
	const [dataGridHistory, setDataGridHistory] = useState<SupplierInventoryGridHistoryResponse[]>([]);

	function handleOpenPartImportModal(dataGridHistory: SupplierInventoryGridHistoryResponse) {
		setDataRowHistory(dataGridHistory);
		setOpenPartImport(true);
	}

	function closeModalPartImport() {
		setGuidSupplierInventoryDetail("");
		setOpenPartImport(false);
	}

	function handleOpenInventoryEditModal(id: string, userName: string) {
		setGuidSupplierInventoryDetail(id);
		setOpenInventoryEdit(true);
		setUserName(userName);
	}

	function closeModalInventoryEdit() {
		setGuidSupplierInventoryDetail("");
		setOpenInventoryEdit(false);
	}

	function onResetSearchHistory() {
		setDataGridHistory([]);
		sertFormFiltersHistory(null);
	}

	async function fetchDataHistory(request: any) {
		return supplierInventoryHistoryApi.getHistoryInventory(request).then((response) => response.data);
	}
	async function loadHistoryInventory(
		filters: SupplierInventoryRequest | Partial<SupplierInventoryRequest> = {},
		isResetSearch: boolean = true,
	) {
		const request: SupplierInventoryRequest = {
			...(isResetSearch ? {} : formFiltersHistory),
			...(filters as SupplierInventoryRequest),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};
		onResetSearchHistory();
		sertFormFiltersHistory(request);
	}

	useEffect(() => {
		loadHistoryInventory({
			guidSupplierInventory: guidSupplierInventory,
			guidWarehouse: dataInventory?.guidWarehouse,
		});
	}, [guidSupplierInventory, JSON.stringify(dataInventory)]);
	return (
		<>
			<S.Container>
				<SP.HeaderSection>
					<SP.HeaderText>{getTranslateByKey("information.history")}</SP.HeaderText>
				</SP.HeaderSection>
				<S.ContainerBodyHistory id={ID_SCROLLABLE_TARGET}>
					<KOGPaginationGrid
						idScrollableTarget={ID_SCROLLABLE_TARGET}
						dataGrid={dataGridHistory}
						formFilters={formFiltersHistory}
						setDataGrid={setDataGridHistory}
						fetchMore={fetchDataHistory}
					>
						<BoxGrid
							rowHeaders={[
								getTranslateByKey("information.description"),
								getTranslateByKey("information.amountInStock"),
								getTranslateByKey("information.dateTimeUser"),
								"",
							]}
							marginCustom="0"
						>
							{dataGridHistory.map((item, index) => (
								<TableRow key={`${item.guidSupplierInventoryHistory}-${index}`}>
									<TableCell width="20%">{item.description}</TableCell>
									<TableCell width="20%">{item.stock}</TableCell>
									<S.TableCellMobile width="15%">{`${item.formattedDateTime} - ${item.userName}`}</S.TableCellMobile>
									<TableCell width="15%" align="right">
										<S.TableIcons>
											<Search
												fontSize="medium"
												style={{ cursor: "pointer" }}
												onClick={() => {
													if (item.idAction === SupplierInventoryHistoryEnum.Edited) {
														handleOpenInventoryEditModal(item.guidSupplierInventoryHistory, item.userName);
													} else if (
														item.idAction === SupplierInventoryHistoryEnum.Imported ||
														item.idAction === SupplierInventoryHistoryEnum.Added
													) {
														handleOpenPartImportModal(item);
													} else {
														openNewTab(
															`${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${Number(
																item.orderNumber,
															)}&startDate=${item.orderDate}&finalDate=${formatDateToISOString(
																new Date(item.orderDate),
															)}`,
														);
													}
												}}
											/>
										</S.TableIcons>
									</TableCell>
								</TableRow>
							))}
						</BoxGrid>
					</KOGPaginationGrid>
				</S.ContainerBodyHistory>
			</S.Container>
			<PartImport open={openPartImport} closeModal={closeModalPartImport} dataRowHistory={dataRowHistory} />
			<InventoryEdit
				open={openInventoryEdit}
				closeModal={closeModalInventoryEdit}
				guidSupplierInventoryDetail={guidSupplierInventoryDetail}
				userName={userName}
			/>
		</>
	);
}

export default SectionHistory;
